var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckInDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_961_5873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.916992,
    y: 0.425781,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_961_5873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9151 7.92384C12.4845 7.92384 12.1176 7.77159 11.8144 7.46709C11.5111 7.16259 11.3594 6.79501 11.3594 6.36434C11.3594 5.93351 11.5116 5.56651 11.8161 5.26334C12.1206 4.96018 12.4883 4.80859 12.9191 4.80859C13.3498 4.80859 13.7167 4.96084 14.0199 5.26534C14.3232 5.56984 14.4749 5.93743 14.4749 6.36809C14.4749 6.79893 14.3226 7.16593 14.0181 7.46909C13.7136 7.77226 13.346 7.92384 12.9151 7.92384ZM11.2441 19.0008V15.0968H11.1479C10.8919 15.0968 10.6772 15.0103 10.5039 14.8371C10.3307 14.6638 10.2441 14.4491 10.2441 14.1931V10.6353C10.2441 10.1753 10.408 9.78151 10.7356 9.45384C11.0631 9.12618 11.457 8.96234 11.9171 8.96234H13.9171C14.3773 8.96234 14.7711 9.12618 15.0986 9.45384C15.4263 9.78151 15.5901 10.1753 15.5901 10.6353V14.1931C15.5901 14.4491 15.5036 14.6638 15.3304 14.8371C15.1571 15.0103 14.9424 15.0968 14.6864 15.0968H14.5901V19.0008C14.5901 19.2568 14.5036 19.4715 14.3304 19.6448C14.1571 19.818 13.9424 19.9046 13.6864 19.9046H12.1479C11.8919 19.9046 11.6772 19.818 11.5039 19.6448C11.3307 19.4715 11.2441 19.2568 11.2441 19.0008Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInDark);
export default __webpack_public_path__ + "static/media/Check-in Dark.8f6fc1d68d237af07dd8ea2454300fdc.svg";
export { ForwardRef as ReactComponent };